import {
    person,
    personFill,
    personPlus,
    personPlusFill,
    eye,
    eyeSlash,
    eyeSlashFill,
    envelopeFill,
    stack,
    list,
    search,
    plus,
    chevronLeft,
    chevronRight,
    threeDotsVertical,
    pencilSquare,
    trash,
    journalText,
    bell,
    filter,
    chevronDown,
    lockFill,
    check2,
    check2All,
    x,
    xLg,
    watch,
    diagram3Fill,
    xCircle,
    checkCircle,
    infoCircle,
    exclamationCircle,
    exclamationTriangleFill,
    peopleFill,
    shieldLockFill,
    clockFill,
    send,
    geoAltFill,
    compassFill,
    arrowsCollapse,
    arrowsExpand,
    arrowLeftRight,
    broadcastPin,
    mapFill,
    arrowsAngleExpand,
    arrowsAngleContract,
    moonFill,
    sunFill,
    headphones,
    gearFill,
} from 'ngx-bootstrap-icons';

export const icons = {
    person,
    personFill,
    personPlus,
    personPlusFill,
    eye,
    eyeSlash,
    eyeSlashFill,
    envelopeFill,
    stack,
    list,
    search,
    plus,
    chevronLeft,
    chevronRight,
    threeDotsVertical,
    pencilSquare,
    trash,
    journalText,
    bell,
    filter,
    chevronDown,
    lockFill,
    check2,
    check2All,
    x,
    xLg,
    watch,
    diagram3Fill,
    xCircle,
    checkCircle,
    infoCircle,
    exclamationCircle,
    exclamationTriangleFill,
    peopleFill,
    shieldLockFill,
    clockFill,
    send,
    geoAltFill,
    compassFill,
    arrowsCollapse,
    arrowsExpand,
    arrowLeftRight,
    broadcastPin,
    mapFill,
    arrowsAngleExpand,
    arrowsAngleContract,
    moonFill,
    sunFill,
    headphones,
    gearFill,
};
